<div class="flex flex-col h-full justify-between">
	<div>
		@for (menuPoint of topItems(); track menuPoint.name) {
			<ui-nav-list-entry
				[menuPoint]="menuPoint"
				[navColor]="navColor()"
				[isActive]="isMenuPointActive(menuPoint)"
				[isHovered]="menuPoint === openItem()"
				(click)="handleEntryClick(menuPoint)"
				(mouseenter)="handleMouseEnter(menuPoint)"
				[attr.data-id]="menuPoint.url"
				[attr.data-cy]="'nav-item-' + (menuPoint.url || menuPoint.callbackAction || menuPoint.name)"
				[attr.data-main-nav-item]="getGlobalIndex(menuPoint, true)"
			>
			</ui-nav-list-entry>
		}
	</div>
	<div>
		@if (beta()) {
			<div class="flex justify-center mb-3">
				<ui-tag [text]="betaTranslation()" type="dark"></ui-tag>
			</div>
		}
		@for (menuPoint of bottomItems(); track menuPoint.name) {
			<ui-nav-list-entry
				[menuPoint]="menuPoint"
				[navColor]="navColor()"
				[isActive]="isMenuPointActive(menuPoint)"
				[isHovered]="menuPoint === openItem()"
				(click)="handleEntryClick(menuPoint)"
				(mouseenter)="handleMouseEnter(menuPoint)"
				[attr.data-id]="menuPoint.url"
				[attr.data-cy]="'nav-item-' + (menuPoint.url || menuPoint.callbackAction || menuPoint.name)"
				[attr.data-main-nav-item]="getGlobalIndex(menuPoint, false)"
			>
			</ui-nav-list-entry>
		}
	</div>
</div>
